﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            autofocus: {
                type: String,
                default : "on"
            }
        }
    }

    connect() {
        this.element.addEventListener("submit", () => this.disableSubmitButtons());
        this.focusAutofocusInput();
    }

    disableSubmitButtons() {
        this.element.querySelectorAll("input[submit],button:not([type=button]):not([type=reset])").forEach(sb => {
            sb.disabled = true;
        });
    }

    focusAutofocusInput() {
        if (this.autofocusValue !== "off") {
            const autofocusInput =
                this.element.querySelector(".input-validation-error:not([type=hidden]):not([disabled])") ||
                (
                    this.autofocusValue === "on" &&
                    this.element.querySelector("input:not([type=hidden]):not([disabled]),select:not([disabled])")
                );

            if (autofocusInput) {
                autofocusInput.scrollIntoView(true);
                autofocusInput.focus();
            }
        }
    }
}
